var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.753 16H7.173c-2.09 0-3.95-1.53-4.15-3.61A3.998 3.998 0 0 1 7.002 8h12.36c1.31 0 2.5.94 2.63 2.24a2.5 2.5 0 0 1-2.49 2.76h-10.5c-.55 0-1-.45-1-1s.45-1 1-1h8.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-8.61c-1.31 0-2.5.94-2.63 2.24a2.5 2.5 0 0 0 2.49 2.76h10.33c2.09 0 3.95-1.53 4.15-3.61a3.993 3.993 0 0 0-3.98-4.39H7.233c-2.87 0-5.44 2.1-5.71 4.96a5.505 5.505 0 0 0 5.48 6.04h10.75c.41 0 .75-.34.75-.75s-.34-.75-.75-.75z",
    fill: "#9EA4AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.0a6ab0e226959011b30f61645b9b3253.svg";
export { ForwardRef as ReactComponent };